<div class="content-block">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="content-block">Articolo > <b>{{articolo?.descrizione}}</b></h2>
        <div class="d-flex gap-4">
          <dx-button stylingMode="contained" class="mr-3" text="Torna alla dashboard articolo" icon="home"
            type="success" (onClick)="goToDashboardArticolo()"> </dx-button>

        </div>
      </div>
    </div>
  </div>

  <div class="row">

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">

          <div class="nav-tabs-custom">
            <ul class="nav nav-pills"><!-- data-bs-toggle -->
              <li class="nav-item"><a class="nav-link active" href="#datiaarticolo" data-bs-toggle="tab">DATI
                  ARTICOLO</a>
              </li>
              <li class="nav-item"><a class="nav-link" href="#allegati" data-bs-toggle="tab">ALLEGATI</a></li>
              @if(attivaTabMatricole()){
              <li class="nav-item"><a class="nav-link" href="#matricole" data-bs-toggle="tab">MATRICOLE</a></li>
              }
              @if(tabKit){
              <li class="nav-item"><a class="nav-link" href="#kit" data-bs-toggle="tab">KIT ARTICOLO</a></li>
              }
              <li class="nav-item"><a class="nav-link" href="#scadenze" data-bs-toggle="tab">SCADENZE</a></li>
              <li class="nav-item"><a class="nav-link" href="#consegne" data-bs-toggle="tab">CONSEGNE</a></li>
              <li class="nav-item"><a class="nav-link" href="#movimentazioni" data-bs-toggle="tab">MOVIMENTAZIONI</a>
              </li>
            </ul>
          </div>

          <div class="tab-content">

            <div class="tab-pane active" id="datiaarticolo">
              <app-form-articolo [articolo]="articolo" (eventEmitterArticolo)="onEventEmitterArticolo($event)"></app-form-articolo>
            </div> <!-- /.tab-pane -->

            <div class="tab-pane" id="allegati">
              <app-grid-allegati-articolo [idArticolo]="idArticolo"></app-grid-allegati-articolo>
            </div>
            @if(attivaTabMatricole()){
            <div class="tab-pane" id="matricole">
              <app-grid-matricole-articolo [articolo]="articolo"></app-grid-matricole-articolo>
            </div>
            }

            @if(tabKit){
            <div class="tab-pane" id="kit">
              <app-grid-kit-articoli [idArticolo]="idArticolo"></app-grid-kit-articoli>
            </div>
            }

            <div class="tab-pane" id="scadenze">
              <app-grid-scadenze-articoli [idArticolo]="idArticolo"></app-grid-scadenze-articoli>
            </div>

            <div class="tab-pane" id="consegne">
              <app-articoli-consegnati [idDipendente]="0" [idArticolo]="idArticolo" [filterEnable]=false
                [bConsultazione]="false"></app-articoli-consegnati>
            </div>

            <div class="tab-pane" id="movimentazioni">
              <app-grid-movimentazioni-articoli-dipendenti
                [idArticolo]="idArticolo"></app-grid-movimentazioni-articoli-dipendenti>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>

</div>